import { espApiOrigins } from "../services/api-host-resolver";

// API Facade service identifier headers (UH ADR 8, ESP-22365).
//
// These headers are attribution hints only. They tell the Facade which client
// sent a request. They are not authenticated and must never be used for
// authorization or rate-limit decisions.
//
// They are sent only to the ESP API and TM origins (exact origin match), never
// to the help host, third parties or the webapp's own assets.
export const ORIGINATING_SERVICE_IDENTIFIER_HEADER = "Originating-Service-Identifier";
export const IMMEDIATE_SERVICE_IDENTIFIER_HEADER = "Immediate-Service-Identifier";
export const SERVICE_IDENTIFIER = "ESP-WebappUser";

// Exact origin comparison through URL parsing; no string prefix or substring
// matching. A relative URL resolves to the webapp's own origin, which is never
// an API origin. A URL with userinfo or a malformed URL never matches.
export function isEspApiOrigin(url: string, base: string = document.baseURI,
                               origins: string[] = espApiOrigins()): boolean {
  let u: URL;
  try {
    u = new URL(url, base);
  } catch {
    return false;
  }
  if (u.username !== "" || u.password !== "") {
    return false;
  }
  return origins.includes(u.origin);
}

// Both identifier headers when url is on an ESP API origin, otherwise none.
export function serviceIdentifierHeaders(url: string, base?: string,
                                         origins?: string[]): Record<string, string> {
  if (!isEspApiOrigin(url, base, origins)) {
    return {};
  }
  return {
    [ORIGINATING_SERVICE_IDENTIFIER_HEADER]: SERVICE_IDENTIFIER,
    [IMMEDIATE_SERVICE_IDENTIFIER_HEADER]: SERVICE_IDENTIFIER,
  };
}
